import styled from '@emotion/styled';
import { darken } from 'polished';
import { InternalLink } from 'gatsby-theme-apollo';

const TipBox = styled.div`
  display: flex;
  margin-top: 4px;
  border-radius: ${props => props.theme.radius};
  background-color: ${props => darken(0.1, props.theme.backgroundSemiTransparent)};
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  padding: 10px;
`;

const TipContent = styled.div`
  display: flex;
  margin-left: 10px;
  flex-direction: column;
  height: 100%;
  align-items: flex-start;
  justify-content: center;
`;

const TipText = styled.h4`
  width: 100%;
  margin: 0px;
`;

const TipDate = styled.span`
  color: rgba(255, 255, 255, 0.3);
`;

const TipAuthor = styled(InternalLink)({
  color: `rgba(255, 255, 255, 0.5)`,
  marginTop: `5px`
});

const Author = styled.div({
  fontWeight: `bold`
});

const PostDate = styled.div({
  marginLeft: `5px`,
  color: `rgba(255, 255, 255, 0.3)`
});

const Content = styled.div(props => ({
  wordBreak: `break-word`,
  color: props.theme.subtleText
}));

const ByLine = styled.div({
  display: `flex`
});
const Spacer = styled.div({
  marginTop: `5px`
});

const AuthorBadge = styled.div(props => ({
  textIndent: `5px`,
  color: props.theme.subtleText,
  display: `inline-block`
}));

const UserTextBox = styled.div(props => ({
  display: `flex`,
  flexDirection: `column`,
  flexWrap: `wrap`,
  borderRadius: props.theme.radius,
  padding: `5px 10px`,
  margin: `2px`
}));

export {
  TipBox,
  TipContent,
  TipText,
  TipDate,
  TipAuthor,
  Author,
  PostDate,
  Content,
  ByLine,
  Spacer,
  AuthorBadge,
  UserTextBox
};
